export const TypographyPrimitives = {
  fontFamily: {
    "abc-social": [
      "ABCSocial",
      "Helvetica Neue",
      "Helvetica",
      "Arial",
      "sans-serif",
    ],
    "abc-social-mono": [
      "ABCSocial Mono",
      "Helvetica Neue",
      "Helvetica",
      "Arial",
      "sans-serif",
    ],
    druk: ["Druk", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"],
  },
  fontWeight: {
    book: 350,
    regular: 400,
    medium: 500,
    bold: 700,
  },
  fontSize: {
    10: "10px",
    12: "12px",
    14: "14px",
    16: "16px",
    18: "18px",
    20: "20px",
    24: "24px",
    28: "28px",
    32: "32px",
    40: "40px",
    48: "48px",
    56: "56px",
    88: "88px",
    160: "160px",
  },
  letterSpacing: {
    normal: "0px",
    "wide-1": "1px",
    "tight-1": "-2px",
    "tight-2": "-3px",
  },
  lineHeight: {
    14: "14px",
    16: "16px",
    20: "20px",
    24: "24px",
    28: "28px",
    30: "30px",
    32: "32px",
    36: "36px",
    40: "40px",
    44: "44px",
    48: "48px",
    52: "52px",
    64: "64px",
    96: "96px",
    160: "160px",
  },
} as const;
